import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../client-budget/client-budget.component';
import { BookingService } from '../../_LOGIC/booking.service';
import { FormControl } from '@angular/forms';
import { EventEmitterService } from '../../_LOGIC/__common/event-emitter.service';
import { ResolverService } from 'src/app/_LOGIC/__common/resolver.service';
@Component({
  selector: 'app-verification-modal',
  templateUrl: './verification-modal.component.html',
  styleUrls: ['./verification-modal.component.css']
})
export class VerificationModalComponent {

  modalData;
  password;

  hide = true;
  termsAndConditions = false;

  pass = new FormControl('');


  constructor(public dialogRef: MatDialogRef<VerificationModalComponent>,@Inject(MAT_DIALOG_DATA) public data: DialogData,private resolver: ResolverService,private bookingService: BookingService,
  private eventEmitterService: EventEmitterService) {
    this.modalData = data;

    if (this.eventEmitterService.subsVar==undefined) {    
      this.eventEmitterService.subsVar = this.eventEmitterService.    
      invokeLoginAttemptFunction.subscribe((data:any) => {
        debugger
        data? this.closeModal(data) : null ;
        
      });    
    }
  }

  onNoClick(): void {
    this.modalData.confirmation = false;
  }

  confirm(){
    this.modalData.confirmation = true;
  }

  onKeyUp(event){
    if (event.key && event.key === "Enter") {
      this.resolver.tryToValidate(this.password);
    }
  }

  isLoading(){
    return this.resolver.isLoading('validated');
  }

  validatePass(){
    this.resolver.setIsLoading('validated',true);
    this.resolver.tryToValidate(this.password);
  }

  isVisible(){
    if(!this.resolver.getDependency('validated')){
      return true;
    }else{
      this.dialogRef.close()
    }
  }

  closeModal(data){
    debugger
    data?  this.dialogRef.close() : null;
  }
}